import type { IconName, IconSize } from "@similarweb/icons";
import { Locked, SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import type { IDropDownItem } from "@similarweb/ui-components";

import type { Translatable } from "app/pages/sales-intelligence/types";

import I18n from "../../i18n/I18n";

import { StyledDropdownItem, StyledItemText, StyledLockedIconContainer } from "./styles";

type MenuItemViewProps = IDropDownItem & {
    dataAutomation: string;
    iconName: IconName;
    iconSize?: IconSize;
    iconStroke?: string;
    itemText: Readonly<Translatable>;
};

const MenuItemView = (props: MenuItemViewProps) => {
    const { iconName, iconSize = "sm", itemText, disabled, ...rest } = props;

    return (
        <StyledDropdownItem
            {...rest}
            disabled={disabled}
        >
            <SWReactIcons
                iconName={iconName}
                size={iconSize}
            />
            <I18n
                element={StyledItemText}
                data-automation="menu-item-text"
                translatable={itemText}
            />
            {disabled ? (
                <StyledLockedIconContainer>
                    <Locked
                        size={24}
                        color={colorsPalettes.carbon[200]}
                    />
                </StyledLockedIconContainer>
            ) : null}
        </StyledDropdownItem>
    );
};

export default MenuItemView;
